export var CardValidationErrors = {
    expiryMontError: "Invalid Expiry Month",
    expiryYearError: "Invalid Expiry Year",
    cardNumberError: "Invalid Card Number",
    cvvError: "Invalid CVV",
    emptyCardNumber: "Enter a card number",
    invalidCardNumber: "Invalid Card Number",
    luhnValidationMsg: "Card Number does not pass Luhn validation",
    emptyExpiryDate: "Enter an expiry date",
    yearOutOfRange: "Expiry year cannot be in the past",
    monthOutOfRange: "Expiry month must be between 01 and 12",
    dateOutOfRange: "Expiry date cannot be in the past",
    emptyCVV: "Enter a CVV",
    emptyZip: "Enter a ZIP code",
    invalidExpiryDate: "Expiry date is invalid",
    invalidCVV: "CVV is invalid"
};
